export default __webpack_public_path__ + "static/jireh-f2f43c26a34a53c519fadeeb68a29821.jpg";